// src/propertyManagement/pages/PMPaymentProcessing.jsx
import React, { useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

export default function PMPaymentProcessing() {
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/pm/maintenance/paymentComplete', { state });
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate, state]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh'
      }}
    >
      <CircularProgress size={80} />
      <Typography variant="h6" sx={{ mt: 2 }}>Processing payment...</Typography>
    </Box>
  );
}